<div class="form-check form-switch mx-4 my-2">
    <input class="form-check-input fs-24" type="checkbox" role="switch" id="{{label}}" [checked]="checked"
        (change)="onToggle()">
    <label class="form-check-label mt-2 fs-14 fg-400 text-color" [for]="label">
        {{ label | translate }}
    </label>
</div>